import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';


interface GridElementSharedProps {
	headersLength: number;
}


export const GridError = (props: GridElementSharedProps) => {
	const { headersLength } = props;
	const { t } = useTranslation('global');

	return (
		<div
			className="app-grid-cell row-cell"
			style={{ gridColumn: `1 / ${headersLength + 1}` }}
		>
			<p>{t('errorMessage')}</p>
		</div>
	);
};


export const GridEmpty = (props: GridElementSharedProps) => {
	const { headersLength } = props;
	const { t } = useTranslation('global');

	return (
		<div
			className="app-grid-cell row-cell"
			style={{ gridColumn: `1 / ${headersLength + 1}` }}
		>
			<p>{t('gridMessages.noRecords')}</p>
		</div>
	);
};


export const GridLoading = (props: GridElementSharedProps) => {
	const { headersLength } = props;
	return (
		<div
			className="app-grid-cell row-cell"
			style={{ gridColumn: `1 / ${headersLength + 1}` }}
		>
			<FontAwesomeIcon className="loading-icon fa-spin" icon={faSpinner} />
		</div>
	);
};


export const GridNoParams = (props: GridElementSharedProps) => {
	const { headersLength } = props;
	const { t } = useTranslation('global');

	return (
		<div
			className="app-grid-cell row-cell"
			style={{ gridColumn: `1 / ${headersLength + 1}` }}
		>
			<p>{t('gridMessages.noParams')}</p>
		</div>
	);
};